import { IExternalItem } from 'interfaces/external_items';
import { Show } from '@refinedev/antd';
import { Typography } from 'antd';
import { formatDate } from 'services/date';
import { useShow } from '@refinedev/core';

const { Title, Text } = Typography;

export const ExternalItemShow = () => {
  const { queryResult } = useShow<IExternalItem>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading} title="Visualizar item externo">
      <Title level={5}>ID</Title>
      <Text>{record?.id}</Text>

      <Title level={5}>Nome</Title>
      <Text>{record?.name}</Text>

      <Title level={5}>URL do Webhook</Title>
      <Text>
        {record?.webhook_url ? (
          <a
            href={record.webhook_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {record.webhook_url}
          </a>
        ) : (
          '-'
        )}
      </Text>

      <Title level={5}>URL de Acesso</Title>
      <Text>
        {record?.access_url ? (
          <a href={record.access_url} target="_blank" rel="noopener noreferrer">
            {record.access_url}
          </a>
        ) : (
          '-'
        )}
      </Text>

      <Title level={5}>Duração (horas)</Title>
      <Text>{record?.duration_in_hours || '-'}</Text>

      <Title level={5}>Criado em</Title>
      <Text>
        {record?.created_at ? formatDate(record.created_at.toString()) : '-'}
      </Text>

      <Title level={5}>Atualizado em</Title>
      <Text>
        {record?.updated_at ? formatDate(record.updated_at.toString()) : '-'}
      </Text>
    </Show>
  );
};
